<div *transloco="let tloco; prefix: 'subscriptions.my-subscription'" class="h-full rounded-md border border-steel-20">
  <div class="flex flex-col gap-y-6 p-3 md:p-6">
    <div class="flex gap-x-2">
      <img alt="" class="h-6 w-6" [src]="smRenownedLogoPath | staticImageUrl" />
      <span class="text-button md:mb-4">{{ tloco('insights-rma') }}</span>
    </div>
    <div class="flex">
      @if (!!reviews) {
        <rma-stat-block class="flex w-1/2 flex-col" [blurb]="tloco('insights-reviews', { count: reviews })" [value]="reviews" />
      }
      @if (!!exposures) {
        <rma-stat-block class="flex w-1/2 flex-col" [blurb]="tloco('insights-exposures', { count: exposures })" [value]="exposures" />
      }
    </div>
  </div>
</div>
